import BreadcrumbContainer from "../../Componant/BonusUI/Breadcrumb";

const Breadcrumbs = () => {
  return (
    <div className="page-body">
      <BreadcrumbContainer />
    </div>
  );
};

export default Breadcrumbs;
